import { useState, useEffect, useContext } from 'react';
import {Context} from '../Context';
import './VendorRequests.css'
import newVendorRequestService from '../Services/VendorRequestService';
import moment from 'moment';
import { SERVER_URL } from '../Constants';

import { FaFlag, FaBox, FaHammer,FaSearch,FaArrowUp,FaArrowDown,FaFilePdf,FaCheck,FaCopy,FaCheckCircle,FaSyncAlt } from "react-icons/fa";
import { RiGovernmentFill } from "react-icons/ri";
import { GiScales,GiTemporaryShield } from "react-icons/gi";
import { MdPayments } from "react-icons/md";
import { RotatingLines } from "react-loader-spinner";
import { PiUnionFill } from "react-icons/pi";
import { LuUtilityPole } from "react-icons/lu";
import { MdContactSupport } from "react-icons/md";


const type1099Deictionary = {
    'Non-Employee Compensation' : 'NEC01',
    'Rents' : 'MISC01',
    'Gross Proceeds Paid to an Attorney' : 'MISC10',
}; 

const organizeDate = (date) => {
    return moment(date).format("MMM Do YYYY");
};

const DropDownSelection = ({title, options, setTo, width, initializedValue}) => {
    const inputCssProps = {
        '--inputWidth': `${width}px`
    };

    const selectOption = (value) => {
         setTo(value);
    };

    return(
        <div className='Customer-Request-Form-Input' style={inputCssProps}>
            <div className='Customer-Request-Form-Input-Title'>
                {title}
            </div>

            <select className='Customer-Request-Form-Dropdown' onChange={(e) => selectOption(e.target.value)} value={initializedValue || ''}>
                <option value="">Select {title}</option>
                {options.map((option, key) => (
                    <option className='Customer-Request-Form-Dropdown-Selection' key={key} value={option}>{option}</option>
                ))}
            </select>
        </div>
    )
};

const SearchBar = ({setSearchInput,searchList, selectSearchItem}) => {
    const [ focused, setFocused ] = useState(false);

    const handleSearchItemClick = (businessName) => {
        selectSearchItem(businessName);
        setFocused(false);
        document.getElementById('myInput').value = ''
        setSearchInput('');
    };

    return(      
        <div className='Vendor-Request-Header-Search' onClick={() => setFocused(true)}  onMouseLeave={() => setFocused(false)}>
            <FaSearch  className='Vendor-Request-Header-Search-Icon'/>
            <input autoComplete="off"  onChange={((e) => setSearchInput(e.target.value))} id="myInput" className='Vendor-Request-Header-Search-Text' placeholder='Search Vendors'/>

            {   focused && searchList && 
            <div className='Vendor-Request-Header-Search-List'>
            {   
                searchList.map((object, key) => (
                    <div key={key} className='Vendor-Request-Header-Search-Term' onClick={(event) => {handleSearchItemClick(object.business_name); event.stopPropagation()}}>
                        {object.business_name}
                    </div>
                ))
            }
            </div>
            }

        </div>
    )
};

const ActiveSelector = ({activeSort,setActiveSort}) => {
    return(
        <div className='Vendor-Request-Header-Active'>

            {   activeSort && activeSort !== 'both' &&
            <div className='Vendor-Request-Header-Select Selected-Active'>
                Active
            </div>
            }
            { activeSort === 'both' &&
            <div className='Vendor-Request-Header-Select ' onClick={() => setActiveSort(true)}>
                Active
            </div>
            }
            {   !activeSort &&
            <div className='Vendor-Request-Header-Select ' onClick={() => setActiveSort(true)}>
                Active
            </div>
            }


            <div className='Vendor-Request-Header-Select-Divider'/>

            {   !activeSort &&
            <div className='Vendor-Request-Header-Select Selected-Active'>
                InActive
            </div>
            }
            {   activeSort &&
            <div className='Vendor-Request-Header-Select' onClick={() => setActiveSort(false)}>
                InActive
            </div>  
            }

            <div className='Vendor-Request-Header-Select-Divider'/>

            {   activeSort === 'both' &&
            <div className='Vendor-Request-Header-Select Selected-Active'>
                Both
            </div>
            }
            {   activeSort !== 'both' &&
            <div className='Vendor-Request-Header-Select' onClick={() => setActiveSort('both')}>
                Both
            </div>  
            }
        </div>
    )
};

const ControlBar = ({resetList,activeSort,setActiveSort,openManualVerification}) => {
    return(
        <div className='Vendor-Request-Header-Controls'>
            <ActiveSelector activeSort={activeSort} setActiveSort={setActiveSort}/>
            <button onClick={() => resetList()} className='Vendor-Request-Header-All-Button'>Default View</button>
            <button onClick={() => openManualVerification()} className='Vendor-Request-Header-All-Button'>Manual Account Verification</button>
        </div>
    )
};

const SortDirectionIndicator = ({currentSelection, validSelection, direction}) => {
    if(currentSelection === validSelection){
        if(direction === 'ASC') return <FaArrowUp />
        else return <FaArrowDown />
    }

};

const BottomHeader = ({screenWidth, sortDirection, orderBy, handleOrderClick, headerFilters, setHeaderFilters}) => {
    const updateFilter = (field, value) => {
        setHeaderFilters((previousFilters) => ({
            ...previousFilters,
            [field]: value,
        }));
    };

    return(
        <div className='Vendor-Request-Bottom-Header'>

            <div className='Vendor-Request-Tile-Information'>
                <div className='Vendor-Header-Cell'>
                    <button type='button' className='Vendor-Header-Button' onClick={() => handleOrderClick('vendor_type')}>
                        Request Type <SortDirectionIndicator currentSelection={orderBy} validSelection={'vendor_type'} direction={sortDirection}/>
                    </button>
                    <input
                        className='Vendor-Header-Filter-Input'
                        value={headerFilters.requestType}
                        onChange={(event) => updateFilter('requestType', event.target.value)}
                        placeholder='Filter request type'
                    />
                </div>

                <div className='Vendor-Header-Cell'>
                    <button type='button' className='Vendor-Header-Button' onClick={() => handleOrderClick('business_name')}>
                        Business Name <SortDirectionIndicator currentSelection={orderBy} validSelection={'business_name'} direction={sortDirection}/>
                    </button>
                    <input
                        className='Vendor-Header-Filter-Input'
                        value={headerFilters.businessName}
                        onChange={(event) => updateFilter('businessName', event.target.value)}
                        placeholder='Filter business name'
                    />
                </div>

                {   screenWidth > 1000 &&
                <div className='Vendor-Header-Cell'>
                    <button type='button' className='Vendor-Header-Button' onClick={() => handleOrderClick('city')}>
                        Business Location <SortDirectionIndicator currentSelection={orderBy} validSelection={'city'} direction={sortDirection}/>
                    </button>
                    <input
                        className='Vendor-Header-Filter-Input'
                        value={headerFilters.location}
                        onChange={(event) => updateFilter('location', event.target.value)}
                        placeholder='Filter city or state'
                    />
                </div>
                }

                <div className='Vendor-Header-Cell'>
                    <button type='button' className='Vendor-Header-Button' onClick={() => handleOrderClick('date')}>
                        Date Received <SortDirectionIndicator currentSelection={orderBy} validSelection={'date'} direction={sortDirection}/>
                    </button>
                    <input
                        className='Vendor-Header-Filter-Input'
                        value={headerFilters.date}
                        onChange={(event) => updateFilter('date', event.target.value)}
                        placeholder='Filter date'
                    />
                </div>

                {screenWidth > 1000 &&
                <div className='Vendor-Header-Cell Vendor-Header-Cell-Flag' aria-hidden='true' />
                }
            </div>

        </div>
    )
};

const VendorRequestHeader = ({vendorHeaderObject}) => {
    const {setSearchInput,sortDirection,flipSortOrder,screenWidth, orderBy, handleOrderClick, searchList, selectSearchItem,resetList, 
        activeSort, setActiveSort, headerFilters, setHeaderFilters, openManualVerification} = vendorHeaderObject;
    return(
        <div className='Vendor-Request-Header'>
            <div className='Vendor-Request-Top-Header'>
                <SearchBar setSearchInput={setSearchInput} searchList={searchList} selectSearchItem={selectSearchItem}/>
                <ControlBar resetList={resetList} activeSort={activeSort} setActiveSort={setActiveSort} openManualVerification={openManualVerification}/>
            </div>
            <BottomHeader
                screenWidth={screenWidth}
                sortDirection={sortDirection}
                orderBy={orderBy}
                handleOrderClick={handleOrderClick}
                headerFilters={headerFilters}
                setHeaderFilters={setHeaderFilters}
            />

        </div>
    )
};

const TileHoverPanel = ({vendor,toggleFlag}) => {
    return (
        <div className='Vendor-Request-Flag-Frame'>
            {   vendor.flag &&
                <FaFlag className='Vendor-Request-Flag-Checked' onClick={(event) => {toggleFlag(vendor.id); event.stopPropagation()}}/>
            }
            {   !vendor.flag &&
                <FaFlag className='Vendor-Request-Flag-Unchecked' onClick={(event) => {toggleFlag(vendor.id); event.stopPropagation()}}/>
            }
            
        </div>
    )
};

const VendorTile = ({vendor, selectVendorRecord, toggleFlag, screenWidth}) => {
    const [ hover, setHover ] = useState();
const vendorTypeOptions = [ '', '','','','','Utilities Provider','Labor Union', 'Temp Labor'];
    return(
        <div className='Vender-Request-Tile' onClick={() => selectVendorRecord(vendor.id)} onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)}>
            { vendor.vendor_type === 'Supplier' &&
                <FaBox className='Vendor-Request-Tile-Image'/>
            }
            { vendor.vendor_type === 'Subcontractor' &&
                <FaHammer className='Vendor-Request-Tile-Image'/>
            }
            { vendor.vendor_type === 'Government' &&
                <RiGovernmentFill className='Vendor-Request-Tile-Image'/>
            }
            { vendor.vendor_type === 'Attorney' &&
                <GiScales className='Vendor-Request-Tile-Image'/>
            }
            { vendor.vendor_type === 'Utilities Provider' &&
                <LuUtilityPole className='Vendor-Request-Tile-Image'/>
            }
            { vendor.vendor_type === 'Rent' &&
                <MdPayments className='Vendor-Request-Tile-Image'/>
            }
            {   vendor.vendor_type === 'Labor Union' &&
                <PiUnionFill className='Vendor-Request-Tile-Image'/>
            }
            {   vendor.vendor_type === 'Temp Labor' &&
                <GiTemporaryShield className='Vendor-Request-Tile-Image'/>
            }
            {   vendor.vendor_type === 'Sponsor' &&
                <MdContactSupport  className='Vendor-Request-Tile-Image'/>
            }

            <div className='Vendor-Request-Tile-Information'>
                <div className='Vendor-Request-Tile-Data'>
                    {`${vendor.form_type} ${vendor.vendor_type} Request`}
                </div>
                <div className='Vendor-Request-Tile-Data'>
                    {vendor.business_name}
                </div>
                {   screenWidth > 1000 &&
                <div className='Vendor-Request-Tile-Data'>
                    {`${vendor.city}, ${vendor.state}`}
                </div>
                }

                <div className='Vendor-Request-Date'>
                    {organizeDate(vendor.date)}
                </div>
                {   screenWidth > 1000 &&
                <>
                {hover && <TileHoverPanel vendor={vendor} toggleFlag={toggleFlag}/>}
                {!hover &&
                    <div className='Vendor-Request-Flag-Frame'>
                        {   vendor.flag &&
                            <FaFlag className='Vendor-Request-Flag'/>
                        }
                    </div>
                }
                </>
                }
 
            </div>
            
        </div>
    )
};

const EmptyVendorDisplay = () => {
    return(
        <div className='Vendor-Request-No-Display'>
            No Records to Display.
        </div>
    )
};

const VendorRequestDisplay = ({vendorRequestObject}) => {
    const { vendorList, selectVendorRecord, toggleFlag, screenWidth, headerFilters } = vendorRequestObject;

    const normalizedFilters = {
        requestType: (headerFilters.requestType || '').trim().toLowerCase(),
        businessName: (headerFilters.businessName || '').trim().toLowerCase(),
        location: (headerFilters.location || '').trim().toLowerCase(),
        date: (headerFilters.date || '').trim().toLowerCase(),
    };

    const filteredVendorList = vendorList.filter((vendor) => {
        const requestTypeValue = `${vendor.form_type || ''} ${vendor.vendor_type || ''}`.toLowerCase();
        const businessNameValue = `${vendor.business_name || ''}`.toLowerCase();
        const locationValue = `${vendor.city || ''} ${vendor.state || ''}`.toLowerCase();
        const dateValue = organizeDate(vendor.date).toLowerCase();

        return (
            requestTypeValue.includes(normalizedFilters.requestType) &&
            businessNameValue.includes(normalizedFilters.businessName) &&
            locationValue.includes(normalizedFilters.location) &&
            dateValue.includes(normalizedFilters.date)
        );
    });

    return(
        <div className='Vendor-Request-Display'> 
            {   filteredVendorList &&
                filteredVendorList.map((vendor, key) => (
                    <VendorTile key={key} vendor={vendor} selectVendorRecord={selectVendorRecord} toggleFlag={toggleFlag} screenWidth={screenWidth}/>
                ))
            }
            {   filteredVendorList.length < 1 &&
                <EmptyVendorDisplay />
            }
        </div>
    )
};

const ConfirmationWindow = ({title, confirm, deny}) => {
    return(
        <div className='Vendor-Request-Confirmation-Backdrop'>
            <div className='Vendor-Request-Confirmation'>
                <div className='Vendor-Request-Confirmation-Icon'>
                    <FaFlag />
                </div>
                <div className='Vendor-Request-Confirmation-Header'>
                    {title}
                </div>
                <div className='Vendor-Request-Confirmation-Button-Group'>
                    <button onClick={() => confirm()} className='Vendor-Request-Confirmation-Button Vendor-Request-Confirm-Button'>
                        <FaCheck /> Yes
                    </button>
                    <button onClick={() => deny()} className='Vendor-Request-Confirmation-Button Vendor-Request-Deny-Button'>
                        No
                    </button>
                </div>
            </div>
        </div>
    )
};

const ApprovalVendorWindow = ({confirm, deny,approvalProps}) => {    
    const approveConfirmationTitle = 'Please complete the form below to approve this vendor request.';
    const [complete,setComplete] = useState(false);
    const type1099List = Object.keys(type1099Deictionary).map((key) => {
        return `${key} - ${type1099Deictionary[key]}`;
    });
    

    const checkComplete = () => {
        let complete = true;

        if(!approvalProps.require1099) complete=false;
        if(approvalProps.require1099 === 'Yes' && !approvalProps.type1099) complete=false;
        if(!approvalProps.foreignEntity) complete=false;
        if(!approvalProps.isTaxAgency) complete=false;

        return complete;
    };

    useEffect(() => {
        approvalProps.setLandedCost('No')
    },[]);

    useEffect(() => {
        if(checkComplete()) setComplete(true);
        else setComplete(false);
    },[approvalProps.require1099,approvalProps.foreignEntity,approvalProps.landedCost,approvalProps.isTaxAgency]);
    
    return(
        <div className='Customer-Request-Confirmation-Backdrop'>
            <div className='Customer-Request-Confirmation Customer-Request-Approval-Dialog'>
                <div className='Customer-Request-Confirmation-Icon'>
                    <FaCheckCircle />
                </div>
                <div className='Customer-Request-Confirmation-Header'>
                    {approveConfirmationTitle}
                </div>

                {/* General Information Section */}
                <div className='Customer-Request-Form-Section'>
                    <div className='Customer-Request-Approval-Grid'>
                        <DropDownSelection title={'Require 1099'} options={['Yes', 'No']} setTo={approvalProps.setRequire1099} width={130} initializedValue={approvalProps.require1099}/>
                        
                        {approvalProps && approvalProps.require1099 === 'Yes' && (
                            <DropDownSelection title={'1099 Type'} options={type1099List} setTo={approvalProps.setType1099} width={280} initializedValue={approvalProps.type1099}/>
                        )}

                        <DropDownSelection title={'Foreign Entity'} options={['Yes', 'No']} setTo={approvalProps.setForeignEntity} width={130} initializedValue={approvalProps.foreignEntity}/>
                        
                        <DropDownSelection title={'Is Tax Agency'} options={['Yes', 'No']} setTo={approvalProps.setIsTaxAgency} width={130} initializedValue={approvalProps.isTaxAgency}/> 
                    </div>
                </div>

                <div className='Customer-Request-Confirmation-Button-Group'>
                    {complete ? (
                        <button onClick={() => confirm()} className='Customer-Request-Confirmation-Button Customer-Request-Confirm-Button'>
                            <FaCheck /> Approve
                        </button>
                    ) : (
                        <button disabled className='Customer-Request-Confirmation-Button Customer-Request-Confirm-Button'>
                            Complete Form to Approve
                        </button>
                    )}
                    <button onClick={() => deny()} className='Customer-Request-Confirmation-Button Customer-Request-Deny-Button'>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
};

const VendorRecordHeader = ({vendorRecordHeaderObject}) => {
    const {closeVendorRecord,markVendorInactive,markVendorActive,vendorRecord, confirmSelection, openRejection,enterApproval, editRecord, setEditRecord, updateRecord} = vendorRecordHeaderObject;

    const inactiveConfirmationTitle = 'Are you sure you want to mark this vendor record as inactive?';
    const activeConfirmationTitle = 'Are you sure you want to mark this vendor record as active?';

    return(
        <div className='Vendor-Request-Record-Header'>
            {   vendorRecord.active && !editRecord &&
                <button onClick={() => enterApproval()} className='Vendor-Request-Button'>Approve</button>
            }
            {   vendorRecord.active && !editRecord &&
                <button onClick={() => openRejection()} className='Vendor-Request-Button'>Reject</button>
            }
            {   vendorRecord.active && !editRecord &&
                <button onClick={() => confirmSelection(inactiveConfirmationTitle,markVendorInactive)} className='Vendor-Request-Button'>Mark Inactive</button>
            }
            {   !vendorRecord.active && !editRecord &&
                <button onClick={() => confirmSelection(activeConfirmationTitle,markVendorActive)} className='Vendor-Request-Button'>Mark Active</button>
            }
            {   vendorRecord.active && !editRecord &&
                <button onClick={() => setEditRecord(true)} className='Vendor-Request-Button'>Edit</button>
            }
            {   vendorRecord.active && editRecord &&
                <button onClick={() => updateRecord(true)} className='Vendor-Request-Button'>Submit</button>
            }

            <button onClick={() => closeVendorRecord()} className='Vendor-Request-Button Vendor-Request-Button-End'>Exit</button>
        </div>
    )
};

const VendorRecordAddressField = ({title,addressObject,editting}) => {
    if(addressObject && !editting){
        return(
            <div className='Customer-Request-Record-Form-Field'>
                <div className='Customer-Request-Record-Form-Field-Title'>
                    {title}
                </div>
                <div className='Customer-Request-Record-Form-Field-Value'>
                    {`${addressObject.street} ${addressObject.street2 ? addressObject.street2 : ''} ${addressObject.city}, ${addressObject.state} ${addressObject.zip} ${addressObject.country ? addressObject.country : ''}`}
                </div>
            </div>
        )
    }

    if(addressObject && editting){
        return(
            <div className='Customer-Request-Record-Form-Field'>
                <div className='Customer-Request-Record-Form-Field-Title'>
                    {title}
                </div>
                <div className='Customer-Request-Address-Grid'>
                    <div className='Customer-Request-Record-Form-Under'>
                        <input
                            style={{ 'width': '200px' }}
                            value={addressObject.street}
                            onChange={e => addressObject.setStreet(e.target.value)}
                            className='Customer-Request-Record-Form-Input'
                            placeholder="Street Address"
                        />
                        <div className='Customer-Request-Record-Form-Input-Title'>Street:</div>
                    </div>
                    <div className='Customer-Request-Record-Form-Under'>
                        <input 
                            style={{'width':'120px'}} 
                            value={addressObject.street2} 
                            onChange={e => addressObject.setStreet2(e.target.value)} 
                            className='Customer-Request-Record-Form-Input'
                            placeholder="Suite/Unit"
                        />
                        <div className='Customer-Request-Record-Form-Input-Title'>Street2:</div>
                    </div>
                    <div className='Customer-Request-Record-Form-Under'>
                        <input 
                            style={{'width':'150px'}} 
                            value={addressObject.city} 
                            onChange={e => addressObject.setCity(e.target.value)} 
                            className='Customer-Request-Record-Form-Input'
                            placeholder="City"
                        />
                        <div className='Customer-Request-Record-Form-Input-Title'>City:</div>
                    </div>
                    <div className='Customer-Request-Record-Form-Under'>
                        <input 
                            style={{'width':'40px'}} 
                            value={addressObject.state} 
                            onChange={e => addressObject.setState(e.target.value)} 
                            className='Customer-Request-Record-Form-Input'
                            placeholder="ST"
                        />
                        <div className='Customer-Request-Record-Form-Input-Title'>State:</div>
                    </div>
                    <div className='Customer-Request-Record-Form-Under'>
                        <input 
                            style={{'width':'80px'}} 
                            value={addressObject.zip} 
                            onChange={e => addressObject.setZip(e.target.value)} 
                            className='Customer-Request-Record-Form-Input'
                            placeholder="12345"
                        />
                        <div className='Customer-Request-Record-Form-Input-Title'>Zip:</div>
                    </div>
                    <div className='Customer-Request-Record-Form-Under'>
                        <input 
                            style={{'width':'80px'}} 
                            value={addressObject.country} 
                            onChange={e => addressObject.setCountry(e.target.value)} 
                            className='Customer-Request-Record-Form-Input'
                            placeholder="Country"
                        />
                        <div className='Customer-Request-Record-Form-Input-Title'>Country:</div>
                    </div>
                </div>
            </div>
        )
    }
    else{
        return(
            <>
            </>
        )
    }

};

const VendorRecordField = ({title, value, editting=false, selections=[], setTo}) => {
    if(value){
        return(
            <div className='Customer-Request-Record-Form-Field'>
                <div className='Customer-Request-Record-Form-Field-Title'>
                    {title}
                </div>

                {   !editting &&
                <div className='Customer-Request-Record-Form-Field-Value'>
                    {value}
                </div>
                }


                {   editting && selections.length < 1 &&
                <input className='Customer-Request-Record-Form-Field-Input' value={value} onChange={e => setTo(e.target.value)}/>
                }

                {   editting && selections.length > 0 &&
                <select className='Customer-Request-Dropdown'onChange={(e) => setTo(e.target.value)}>
                    <option value={value}>{value}</option>
                    {   selections.map((option, key) => (
                        <option className='Customer-Request-Dropdown-Selection' key={key} value={option}>{option}</option>
                    ))
                    }
                </select>
                }

            </div>
        )   
    }
    else{
        return(
            <>
            </>
        )
    }

};

const VendorRecordListField = ({title,list}) => {
    if(list){
        let listString = '';

        list.forEach(value => {
            if(listString === '') listString = value
            else listString = listString + `, ${value}`;
        });
    
        return(
            <div className='Customer-Request-Record-Form-Field'>
                <div className='Customer-Request-Record-Form-Field-Title'>
                    {title}
                </div>
                <div className='Customer-Request-Record-Form-Field-Value'>
                    {listString}
                </div>
            </div>
        )
    }
    else{
        return(
            <>
            </>
        )
    }

};

const VendorRecordContactField = ({title, contactObject}) => {
    if(contactObject){
        return(
            <div className='Customer-Request-Record-Contact-Form-Field'>
                <div className='Customer-Request-Record-Form-Field-Title'>
                    {title}
                </div>
                <div className='Customer-Request-Record-Form-Field-Spacer'/>

                <div className='Customer-Request-Record-Form-Field-Card'>
                    <div className='Customer-Request-Record-Form-Field-Value'>
                        {`${contactObject.firstName} ${contactObject.lastName}`}
                    </div>
                    {   contactObject.title &&
                    <div className='Customer-Request-Record-Form-Field-Value'>
                        {`${contactObject.title}`}
                    </div>
                    }
                    <div className='Customer-Request-Record-Form-Field-Value'>
                        {`${contactObject.number}${contactObject.extension ? `: ${contactObject.extension}` : ''}`}
                    </div>
                    <div className='Customer-Request-Record-Form-Field-Value'>
                        {`${contactObject.email}`}
                    </div>
                </div>

            </div>
        )
    }
    else{
        return(
            <>
            </>
        )
    }

};

const VendorRecordForm = ({vendorFormObject,vendorRecord,editting}) => {
    const [copiedText, setCopiedText] = useState('');
    const [showCopySuccess, setShowCopySuccess] = useState(false);

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopiedText(text);
            setShowCopySuccess(true);
            setTimeout(() => setShowCopySuccess(false), 2000);
        });
    };

    if(vendorRecord){
        let primaryContactObject = null;
        if(vendorRecord.primaryContact) {
            primaryContactObject = {
                firstName: vendorRecord.primaryContact.firstName,
                lastName: vendorRecord.primaryContact.lastName,
                title: vendorRecord.primaryContact.title,
                number: vendorRecord.primaryContact.number,
                email: vendorRecord.primaryContact.email,
                extension: vendorRecord.primaryContact.extension,
            };
        };

        let primaryRemitContact = null;
        if(vendorRecord.remitContact1) {
            primaryRemitContact = {
                firstName: vendorRecord.remitContact1.firstName,
                lastName: vendorRecord.remitContact1.lastName,
                title: vendorRecord.remitContact1.title,
                number: vendorRecord.remitContact1.number,
                email: vendorRecord.remitContact1.email,
                extension: vendorRecord.remitContact1.extension,
            };
        };
        
        let secondaryRemitContact = null
        if(vendorRecord.remitContact2) {
            secondaryRemitContact = {
                firstName: vendorRecord.remitContact2.firstName,
                lastName: vendorRecord.remitContact2.lastName,
                title: vendorRecord.remitContact2.title,
                number: vendorRecord.remitContact2.number,
                email: vendorRecord.remitContact2.email,
                extension: vendorRecord.remitContact2.extension,
            };
        };        
        
        return(
        <div className='Customer-Request-Record-Form'>
            {/* Basic Information Section */}
            <div className='Customer-Request-Form-Section'>
                <div className='Customer-Request-Section-Header'>
                    <h3>Basic Information</h3>
                </div>
                <div className='Customer-Request-Section-Content'>
                    <div className='Customer-Request-Field-Grid'>
                        <VendorRecordField title={'Date Received:'} value={organizeDate(vendorRecord.date)}/>
                        <VendorRecordField title={'Form Type:'} value={vendorFormObject.formType} editting={false} selections={['New', 'Update']} setTo={vendorFormObject.setFormType}/>
                        {vendorFormObject.notificationEmail && vendorFormObject.notificationEmail != 'null' && (
                            <VendorRecordField title={'Notification Email:'} value={vendorFormObject.notificationEmail}/>
                        )}
                    </div>
                    
                    {vendorRecord.rejection && (
                        <div className='Customer-Request-Rejection-Section'>
                            <div className='Customer-Request-Field-Grid'>
                                <VendorRecordField title={'Rejected on:'} value={organizeDate(vendorRecord.rejection.date)}/>
                                <VendorRecordField title={'Resubmitted on:'} value={`${vendorRecord.rejection.resubmitDate ? organizeDate(vendorRecord.rejection.resubmitDate) : '* Not Resubmitted *'}`}/>
                            </div>
                            {!vendorRecord.rejection.resubmitDate && (
                                <div className='Customer-Request-Rejection-Link-Container'>
                                    <div className='Customer-Request-Rejection-Link-Label'>Rejection Link:</div>
                                    <div className='Customer-Request-Rejection-Link-Row'>
                                        <input 
                                            type="text" 
                                            value={`https://cornerstoneinc.io/newVendor/?sessionId=${vendorRecord.rejection.sessionId}&rejectionId=${vendorRecord.rejection.id}`}
                                            className='Customer-Request-Rejection-Link-Input'
                                            readOnly
                                        />
                                        <button 
                                            className={`Customer-Request-Copy-Button ${showCopySuccess ? 'copied' : ''}`}
                                            onClick={() => copyToClipboard(`https://cornerstoneinc.io/newVendor/?sessionId=${vendorRecord.rejection.sessionId}&rejectionId=${vendorRecord.rejection.id}`)}
                                        >
                                            {showCopySuccess ? <FaCheck /> : 'Copy'}
                                        </button>
                                    </div>
                                    {showCopySuccess && (
                                        <div className='Customer-Request-Copy-Success'>Link copied to clipboard!</div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Company Details Section */}
            <div className='Customer-Request-Form-Section'>
                <div className='Customer-Request-Section-Header'>
                    <h3>Company Details</h3>
                </div>
                <div className='Customer-Request-Section-Content'>
                    <div className='Customer-Request-Field-Grid'>
                        <VendorRecordField title={'Vendor Type:'} value={vendorFormObject.vendorType} editting={editting} selections={['Supplier', 'Subcontractor', 'Government', 'Attorney', 'Rent', 'Utilities Provider','Labor Union', 'Temp Labor','Sponsor']} setTo={vendorFormObject.setVendorType}/>
                        <VendorRecordField title={'EIN / SSN:'} value={vendorRecord.einSsn}/>
                        <VendorRecordField title={'Legal Name:'} value={vendorFormObject.legalName} editting={editting} setTo={vendorFormObject.setLegalName}/>
                        <VendorRecordField title={'Business Name:'} value={vendorFormObject.businessName} editting={editting} setTo={vendorFormObject.setBusinessName}/>
                    </div>
                    <VendorRecordAddressField title={'Business Address:'} addressObject={vendorFormObject.businessAddressObject} editting={editting}/>
                    <VendorRecordListField title={'Business Classifications:'} list={vendorFormObject.vendorRecord.classificationList}/>
                </div>
            </div>

            {/* Contact Information Section */}
            <div className='Customer-Request-Form-Section'>
                <div className='Customer-Request-Section-Header'>
                    <h3>Contact Information</h3>
                </div>
                <div className='Customer-Request-Section-Content'>
                    <div className='Customer-Request-Contact-Grid'>
                        <VendorRecordContactField title={'Primary Contact:'} contactObject={primaryContactObject}/>
                        <VendorRecordContactField title={'Primary Remittance Contact:'} contactObject={primaryRemitContact}/>
                        {secondaryRemitContact && (
                            <VendorRecordContactField title={'Secondary Remittance Contact:'} contactObject={secondaryRemitContact}/>
                        )}
                    </div>
                </div>
            </div>

            {/* Payment Information Section */}
            <div className='Customer-Request-Form-Section'>
                <div className='Customer-Request-Section-Header'>
                    <h3>Payment Information</h3>
                </div>
                <div className='Customer-Request-Section-Content'>
                    <div className='Customer-Request-Field-Grid'>
                        <VendorRecordField title={'Requested Payment Terms:'} value={vendorRecord.paymentTermsName}/> 
                        <VendorRecordField title={'Requested Payment Method:'} value={vendorRecord.paymentMethod}/>
                        <VendorRecordField title={'Currency:'} value={vendorRecord.currency}/>
                    </div>
                </div>
            </div>

            {/* Banking Information Section */}
            {vendorRecord.bankAccount && (
                <div className='Customer-Request-Form-Section'>
                    <div className='Customer-Request-Section-Header'>
                        <h3>Banking Information</h3>
                    </div>
                    <div className='Customer-Request-Section-Content'>
                        <div className='Customer-Request-Field-Grid'>
                            <VendorRecordField title={'Bank Name:'} value={vendorRecord.bankAccount.name}/>
                            <VendorRecordField title={'Name on Account:'} value={vendorRecord.bankAccount.accountName}/>
                            <VendorRecordField title={'Routing Number:'} value={vendorRecord.bankAccount.routingNumber}/>
                            <VendorRecordField title={'Account Number:'} value={vendorRecord.bankAccount.accountNumber}/>
                            <VendorRecordField title={'Account Type:'} value={vendorRecord.bankAccount.accountType}/>
                            {vendorRecord.bankAccount.swift_code && (
                                <VendorRecordField title={'Swift Code:'} value={vendorRecord.bankAccount.swiftCode}/>
                            )}
                        </div>
                        <VendorRecordAddressField title={'Bank Address:'} addressObject={vendorRecord.bankAccount.address}/>
                        {vendorRecord.bankAccount.vendorAddress && (
                            <VendorRecordAddressField title={'Vendor Address on Account:'} addressObject={vendorRecord.bankAccount.vendorAddress}/>
                        )}
                        <VendorRecordContactField title={'Bank Contact:'} contactObject={vendorRecord.bankAccount.contact}/>
                    </div>
                </div>
            )}

            {/* Signature Information Section */}
            <div className='Customer-Request-Form-Section'>
                <div className='Customer-Request-Section-Header'>
                    <h3>Signature Information</h3>
                </div>
                <div className='Customer-Request-Section-Content'>
                    <div className='Customer-Request-Field-Grid'>
                        <VendorRecordField title={'Signer\'s Name:'} value={vendorRecord.signerName}/>
                        <VendorRecordField title={'Signer\'s Title:'} value={vendorRecord.signerTitle}/>
                    </div>
                </div>
            </div>
        </div>
    )
    } else return(<></>)
};

const VendorRecordFile = ({fileName, selectionTitle, id, selectPdf, fileType}) => {
    return(
        <div className='Customer-Request-Record-File' onClick={() => window.open(`${SERVER_URL}${selectionTitle}/${fileName}`)}>
            <div className='Customer-Request-File-Icon-Container'>
                <FaFilePdf className='Customer-Request-Record-File-Image'/>
            </div>
            <div className='Customer-Request-File-Info'>
                <div className='Customer-Request-File-Type'>{fileType}</div>
                <div className='Customer-Request-Record-File-Name'>
                    {fileName}
                </div>
            </div>
        </div>
    )
};

const VendorRecordFiles = ({vendorRecord, selectPdf, rerunTruistVerify, truistVerifying}) => {
    const normalizedPaymentMethod = (vendorRecord?.paymentMethod || '').trim().toLowerCase();
    const showTruistVerify = normalizedPaymentMethod === 'ach';

    const maskSensitiveNumber = (value, visibleDigits = 4) => {
        if (!value) return 'Not provided';
        const cleanedValue = String(value).replace(/\s+/g, '');
        if (cleanedValue.length <= visibleDigits) return cleanedValue;
        return `****${cleanedValue.slice(-visibleDigits)}`;
    };

    const files = [
        vendorRecord.coiPath && {
            fileName: vendorRecord.coiPath,
            selectionTitle: 'Cois',
            id: vendorRecord.coi,
            type: 'Certificate of Insurance'
        },
        vendorRecord.internationalWirePath && {
            fileName: vendorRecord.internationalWirePath,
            selectionTitle: 'InternationalWires',
            id: vendorRecord.internationalWire,
            type: 'International Wire'
        },
        vendorRecord.voidedCheckPath && {
            fileName: vendorRecord.voidedCheckPath,
            selectionTitle: 'VoidedChecks',
            id: vendorRecord.voidedCheck,
            type: 'Voided Check'
        },
        vendorRecord.w9Path && {
            fileName: vendorRecord.w9Path,
            selectionTitle: 'W9s',
            id: vendorRecord.w9,
            type: 'W-9 Form'
        },
        vendorRecord.businessClassificationPath && {
            fileName: vendorRecord.businessClassificationPath,
            selectionTitle: 'BusinessClassifications',
            id: vendorRecord.businessClassification,
            type: 'Business Classification'
        }
    ].filter(Boolean);

    const bankAccount = vendorRecord?.bankAccount || {};
    const validations = vendorRecord?.validations || [];

    const getStatusColor = (status) => {
        switch(status) {
            case 'OPENED_AND_VALID':
            case 'COMPLETE_MATCH':
                return '#28a745'; // Green
            case 'DATA_UNAVAILABLE':
                return '#ffc107'; // Yellow
            case 'CLOSED':
            case 'NOT_MATCH':
                return '#dc3545'; // Red
            default:
                return '#6c757d'; // Gray
        }
    };

    const formatStatus = (status) => {
        return status.replace(/_/g, ' ');
    };

    const getWarningMessage = (code) => {
        const warnings = {
            '8006': 'Invalid First Name',
            '8007': 'Invalid Last Name',
            '8008': 'Invalid Middle Name',
            '8009': 'Invalid Business Name',
            '8010': 'Invalid SSN/TIN Number',
            '8011': 'Invalid Phone Number',
            '8012': 'Invalid Date of Birth',
            '8013': 'Invalid Address Line',
            '8014': 'Invalid City',
            '8015': 'Invalid State Code',
            '8016': 'Invalid Zip Code',
            '8017': 'Invalid Document ID Type',
            '8018': 'Invalid Document ID',
            '8019': 'Invalid Document ID Place',
            '8020': 'Invalid Type',
            '8021': 'Invalid Data Format',
            '8022': 'Invalid Response'
        };
        return warnings[code] || null;
    };

    return(
        <div className='Customer-Request-Record-Files'>
            <div className='Customer-Request-Record-Files-Header'>
                <div className='Customer-Request-Record-Files-Title'>
                    <FaFilePdf className='Customer-Request-Files-Icon' />
                    Attached Files
                </div>
                <div className='Customer-Request-Files-Count'>
                    {files.length} file{files.length !== 1 ? 's' : ''}
                </div>
            </div>
            
            <div className='Customer-Request-Record-Files-List'>
                {files.length > 0 ? (
                    files.map((file, index) => (
                        <VendorRecordFile 
                            key={index}
                            fileName={file.fileName} 
                            selectionTitle={file.selectionTitle} 
                            id={file.id} 
                            selectPdf={selectPdf}
                            fileType={file.type}
                        />
                    ))
                ) : (
                    <div className='Customer-Request-Files-Empty'>
                        <FaFilePdf className='Customer-Request-Files-Empty-Icon' />
                        <div className='Customer-Request-Files-Empty-Text'>
                            No files attached
                        </div>
                    </div>
                )}
            </div>

            {showTruistVerify && (
                <div className='Vendor-Request-Truist-Verify'>
                    <div className='Vendor-Request-Truist-Verify-Header'>
                        <div className='Vendor-Request-Truist-Verify-Title'>
                            Truist Verify
                        </div>
                        <FaSyncAlt 
                            className={`Vendor-Request-Truist-Verify-Refresh ${truistVerifying ? 'spinning' : ''}`}
                            onClick={rerunTruistVerify}
                            title="Refresh Truist Verify"
                        />
                    </div>
                    <div className='Vendor-Request-Truist-Verify-Content'>
                        <div className='Vendor-Request-Truist-Verify-Row'>
                            <span className='Vendor-Request-Truist-Verify-Label'>Account Holder</span>
                            <span className='Vendor-Request-Truist-Verify-Value'>{bankAccount.accountName || 'Not provided'}</span>
                        </div>
                        <div className='Vendor-Request-Truist-Verify-Row'>
                            <span className='Vendor-Request-Truist-Verify-Label'>Bank Name</span>
                            <span className='Vendor-Request-Truist-Verify-Value'>{bankAccount.name || 'Not provided'}</span>
                        </div>
                        <div className='Vendor-Request-Truist-Verify-Row'>
                            <span className='Vendor-Request-Truist-Verify-Label'>Routing</span>
                            <span className='Vendor-Request-Truist-Verify-Value'>{maskSensitiveNumber(bankAccount.routingNumber)}</span>
                        </div>
                        <div className='Vendor-Request-Truist-Verify-Row'>
                            <span className='Vendor-Request-Truist-Verify-Label'>Account</span>
                            <span className='Vendor-Request-Truist-Verify-Value'>{maskSensitiveNumber(bankAccount.accountNumber)}</span>
                        </div>
                        
                        {validations.length > 0 && !truistVerifying && (
                            <div className='Vendor-Request-Truist-Verify-Validations'>
                                <div className='Vendor-Request-Truist-Verify-Validations-Header'>Validations</div>
                                {validations.map((validation, index) => {
                                    const warningMessage = getWarningMessage(validation.code);
                                    return (
                                        <div key={index} className='Vendor-Request-Truist-Verify-Validation'>
                                            <div className='Vendor-Request-Truist-Verify-Validation-Type'>
                                                {validation.type}
                                            </div>
                                            <div className='Vendor-Request-Truist-Verify-Validation-Status' style={{color: getStatusColor(validation.status)}}>
                                                {formatStatus(validation.status)}
                                            </div>
                                            {validation.description && (
                                                <div className='Vendor-Request-Truist-Verify-Validation-Description'>
                                                    {validation.code} - {validation.description}
                                                </div>
                                            )}
                                            {warningMessage && (
                                                <div className='Vendor-Request-Truist-Verify-Validation-Warning'>
                                                    ⚠️ {warningMessage}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
};

const VendorRecordPdfViewer = ({closePdf,selectedPdf}) => {
    return(
        <div className='Vendor-Request-Record-Pdf-Viewer-Window' onClick={() => closePdf()}>

            <div className='Vendor-Request-Record-Pdf-Viewer'>
                {   selectedPdf &&
                <object data={`data:application/pdf;base64,${selectedPdf}`} type="application/pdf" width="100%" height="100%">
                    <p>Failed to Load PDF</p>
                </object>
                }
            </div>
        </div>
    )
};

const RejectionWindow = ({closeRejection, confirmReject,setRejectionText}) => {
    return(
        <div className='Vendor-Request-Confirmation-Backdrop'>
            <div className='Vendor-Request-Rejection-Window'>
                <div className='Vendor-Request-Confirmation-Icon'>
                    <FaFlag />
                </div>
                <div className='Vendor-Request-Confirmation-Header'>
                    Please enter a reason for rejecting this vendor request.
                </div>

                <textarea 
                    className='Vendor-Request-Rejection-Text' 
                    cols="50" 
                    rows="10" 
                    placeholder="Enter rejection reason..."
                    onChange={e => setRejectionText(e.target.value)}
                />

                <div className='Vendor-Request-Confirmation-Button-Group'>
                    <button onClick={() => confirmReject()} className='Vendor-Request-Confirmation-Button Vendor-Request-Confirm-Button'>
                        <FaFlag /> Confirm Rejection
                    </button>
                    <button onClick={() => closeRejection()} className='Vendor-Request-Confirmation-Button Vendor-Request-Deny-Button'>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
};

const VendorRecordWindow = ({vendorRecordObject,accessToken}) => {
    const {vendorRecord, closeVendorRecord,markVendorInactive,markVendorActive,approveVendorRecord, rejectVendorRecord, selectVendorRecord} = vendorRecordObject
    const [ confirmWindow, setConfirmWindow ] = useState(false);
    const [ approvalWindow, setApprovalWindow] = useState(false);
    const [ confirmText, setConfirmText ] = useState('');
    const [ callAfterFunction, setCallAfterFunction ] = useState();
    const [ pdfViewer, setPdfViewer ] = useState(false);
    const [ selectedPdf, setSelectedPdf ] = useState();

    const [ rejecting, setRejecting ] = useState(false);
    const [ rejectionText, setRejectionText ] = useState('');
    const [ truistVerifying, setTruistVerifying ] = useState(false);

    const [currency, setCurrency] = useState('');
    const [require1099, setRequire1099] = useState('');
    const [type1099, setType1099] = useState('');
    const [foreignEntity, setForeignEntity] = useState('');
    const [landedCost, setLandedCost] = useState('');
    const [isTaxAgency, setIsTaxAgency] = useState('');
    const [isLaborUnion, setIsLaborUnion] = useState('');

    const [ editRecord, setEditRecord ] = useState(false);

    const [ formType, setFormType ] = useState('');
    const [ vendorType, setVendorType ] = useState('');
    const [ legalName, setLegalName ] = useState('');
    const [ businessName, setBusinessName ] = useState('');

    const [ bunsinessStreet,setBunsinessStreet ] = useState('');
    const [ bunsinessStreet2,setBunsinessStreet2 ] = useState('');
    const [ bunsinessCity,setBunsinessCity ] = useState('');
    const [ bunsinessState,setBunsinessState ] = useState('');
    const [ bunsinessZip,setBunsinessZip ] = useState('');
    const [ bunsinessCountry,setBunsinessCountry ] = useState('');

    const approvalProps = {
        require1099: require1099,
        setRequire1099: setRequire1099,
        type1099:type1099,
        setType1099:setType1099,
        foreignEntity: foreignEntity,
        setForeignEntity: setForeignEntity,
        landedCost: landedCost,
        setLandedCost: setLandedCost,
        isLaborUnion: isLaborUnion,
        setIsLaborUnion: setIsLaborUnion,
        isTaxAgency:isTaxAgency,
        setIsTaxAgency:setIsTaxAgency,
    };

    useEffect(() => {
        if(vendorRecord){
            setFormType(vendorRecord.formType);
            setVendorType(vendorRecord.vendorType);
            setLegalName(vendorRecord.legalName);
            setBusinessName(vendorRecord.businessName);
            
            if(vendorRecord.businessAddress) {
                setBunsinessStreet(vendorRecord.businessAddress.street);
                setBunsinessStreet2(vendorRecord.businessAddress.street2);
                setBunsinessCity(vendorRecord.businessAddress.city);
                setBunsinessState(vendorRecord.businessAddress.state);
                setBunsinessZip(vendorRecord.businessAddress.zip);
                if(vendorRecord.businessAddress.country)setBunsinessCountry(vendorRecord.businessAddress.country);
            };
        };
    },[vendorRecord]);

    const createVendorRecordObject = () => {
        const updatedRecord = {
            id: vendorRecord.id,
            formType: formType,
            vendorType: vendorType,
            legalName:legalName,
            businessName:businessName,
            addressId:vendorRecord.businessAddress.id,
            street:bunsinessStreet,
            city:bunsinessCity,
            state:bunsinessState,
            zip:bunsinessZip,
            country:bunsinessCountry,
        };
        return updatedRecord;
    };

    const updateRecord = async () => {
        const updatedRecord = createVendorRecordObject();
        const updatedRecordId = await newVendorRequestService.editRecord(accessToken,updatedRecord);
        if(updatedRecordId) setEditRecord(false);        
    };

    const rerunTruistVerify = async () => {
        setTruistVerifying(true);
        await newVendorRequestService.rerunTruistVerify(accessToken, vendorRecord.id).then((res) => {
            if(res.status === 200) selectVendorRecord(vendorRecord.id);
            else alert('Failed to rerun Truist Verify. Please try again later.');
        }).finally(() => {
            setTruistVerifying(false);
        });
    };

    const getW9 = async (id) => {
        const w9 = await newVendorRequestService.getW9(accessToken,id);
        setSelectedPdf(w9);
    };

    const getCoi = async (id) => {
        const coi = await newVendorRequestService.getCoi(accessToken,id);
        setSelectedPdf(coi);
    };

    const getVoidedCheck = async (id) => {
        const coi = await newVendorRequestService.getVoidedCheck(accessToken,id);
        setSelectedPdf(coi);
    };

    const getInternationalWire = async (id) => {
        const internationalWire = await newVendorRequestService.getInternationalWire(accessToken,id);
        setSelectedPdf(internationalWire);
    };

    const closePdf = () => {
        setPdfViewer(false);
        setSelectedPdf(null);
    };

    const selectPdf = (selection, id) => {
        setPdfViewer(true);
        if(selection === 'Coi') getCoi(id);
        if(selection === 'W9') getW9(id);
        if(selection == 'VoidedCheck') getVoidedCheck(id);
        if(selection == 'InternationalWire') getInternationalWire(id);
    };

    const denySelection = () => {
        setConfirmText('');
        setConfirmWindow(false);
    };

    const approveVendor = () => {
        approveVendorRecord(currency,require1099,type1099,foreignEntity,landedCost,isTaxAgency);
    };

    const approveSelection = () => {
        setConfirmText('');
        setConfirmWindow(false);
        callAfterFunction();
    };

    const closeRejection = () => {
        setRejecting(false);
    };

    const confirmReject = () => {
        rejectVendorRecord(rejectionText,closeRejection);
    };

    const openRejection = () => {
        setRejecting(true);
    };

    const exitApproval = () => {
        setApprovalWindow(false);
    };

    const enterApproval = () => {
        setApprovalWindow(true);
    };

    const confirmSelection = (text,confirmFunction) => {
        setConfirmText(text);
        setConfirmWindow(true);
        setCallAfterFunction(() => confirmFunction);
    };

    const vendorRecordHeaderObject = {
        closeVendorRecord:closeVendorRecord,
        markVendorInactive:markVendorInactive,
        markVendorActive:markVendorActive,
        vendorRecord:vendorRecord,
        confirmSelection:confirmSelection,
        approveVendorRecord:approveVendorRecord,
        openRejection:openRejection,
        editRecord:editRecord,
        setEditRecord:setEditRecord,
        updateRecord:updateRecord,
        enterApproval:enterApproval,
    };
    
    const businessAddressObject = {
        street:bunsinessStreet,
        setStreet: setBunsinessStreet,
        street2:bunsinessStreet2,
        setStreet2: setBunsinessStreet2,
        city:bunsinessCity,
        setCity: setBunsinessCity,
        state:bunsinessState,
        setState: setBunsinessState,
        zip:bunsinessZip,
        setZip: setBunsinessZip,
        country:bunsinessCountry,
        setCountry: setBunsinessCountry,
    };

    const vendorFormObject = {
        vendorRecord:vendorRecord,
        editRecord:editRecord,
        formType:formType,
        setFormType:setFormType,
        vendorType:vendorType,
        setVendorType:setVendorType,
        legalName:legalName,
        setLegalName:setLegalName,
        businessName:businessName,
        setBusinessName:setBusinessName,
        businessAddressObject:businessAddressObject,
    };    return(
        <div className='Vendor-Request-Record-Window'>
            {   rejecting &&
                <RejectionWindow closeRejection={closeRejection} confirmReject={confirmReject} setRejectionText={setRejectionText}/>
            }
            {   !confirmWindow && !approvalWindow && !rejecting &&
            <>
                <VendorRecordHeader vendorRecordHeaderObject={vendorRecordHeaderObject}/>                <div className='Customer-Request-Record-Content'>
                    <div className='Customer-Request-Record-Main'>
                        {vendorRecord && (
                            <VendorRecordForm vendorFormObject={vendorFormObject} vendorRecord={vendorRecord} editting={editRecord}/>
                        )}
                    </div>
                    <div className='Customer-Request-Record-Sidebar'>
                        {vendorRecord && (
                            <VendorRecordFiles vendorRecord={vendorRecord} selectPdf={selectPdf} rerunTruistVerify={rerunTruistVerify} truistVerifying={truistVerifying}/>
                        )}
                    </div>
                </div>
            </>
            }
            {   approvalWindow &&
                <ApprovalVendorWindow title={confirmText} confirm={approveVendor} deny={exitApproval} approvalProps={approvalProps}/>
            }
            {   confirmWindow && 
                <ConfirmationWindow title={confirmText} confirm={approveSelection} deny={denySelection}/>
            }
            {   pdfViewer &&
                <VendorRecordPdfViewer closePdf={closePdf} selectedPdf={selectedPdf}/>
            }
        </div>
    )
};

const Loader = () => {
  return (
    <RotatingLines
      strokeColor="rgb(6, 89, 79)"
      strokeWidth="5"
      animationDuration="0.75"
      width="96"
      visible={true}
    />
  )
};

const ApprovalWindow = ({approvalFinished,closeWindow}) => {
    const [ closing, setClosing ] = useState(false);

    useEffect(() => {
        if(approvalFinished){
            setClosing(true);

            setTimeout(() => {
                closeWindow();
                setClosing(false);
            },1000)};

    },[approvalFinished]);

    return(
        <div className='Vendor-Request-Approval'>
            {   !closing &&
            <>
            <Loader />
            <div className='Vendor-Request-Approval-Text'>
                Please Wait... Approving Vendor.
            </div>
            </>
            }
            {   closing &&
            <>
            <FaCheck className='Vendor-Request-Approval-Symbol' />
            <div className='Vendor-Request-Approval-Text'>
                Approved Vendor Record
            </div>
            </>

            }
        </div>
    )
};

const ManualAccountVerificationModal = ({closeModal, submitVerification}) => {
    // Account verification fields
    const [accountNumber, setAccountNumber] = useState('');
    const [routingNumber, setRoutingNumber] = useState('');
    
    // Owner verification fields
    const [businessName, setBusinessName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [addressLine, setAddressLine] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [einSSN, setEinSSN] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [homePhone, setHomePhone] = useState('');
    const [workPhone, setWorkPhone] = useState('');
    
    // Input formatters
    const formatEinSsn = (value) => {
        const digits = value.replace(/\D/g, '').slice(0, 9);
        if (digits.length <= 2) return digits;
        return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    };

    const formatPhone = (value) => {
        const digits = value.replace(/\D/g, '').slice(0, 10);
        if (digits.length <= 3) return digits;
        if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    };

    // Error handling
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [responseData, setResponseData] = useState(null);
    const [hasSubmitted, setHasSubmitted] = useState(false);

    const hasAnyOwnerInput = () => {
        return businessName || firstName || middleName || lastName || addressLine || city || 
               state || zipCode || einSSN || dateOfBirth || homePhone || workPhone;
    };

    const isValid = () => {
        // Account section is always required
        if (!accountNumber || !routingNumber) return false;
        
        // If any owner field has input, all required owner fields must be filled
        if (hasAnyOwnerInput()) {
            if (!firstName || !lastName || !addressLine || !city || !state || !zipCode || !einSSN) {
                return false;
            }
        }
        
        return true;
    };

    const handleSubmit = async () => {
        if (!isValid()) {
            setErrorMessage('Please fill in all required fields. Account Number and Routing Number are required. If you fill in any owner information, all required owner fields (marked with *) must be completed.');
            return;
        }

        // If work phone is entered and home phone is empty, duplicate work phone to home phone
        const finalHomePhone = homePhone || workPhone;

        const digitsOnly = (val) => val.replace(/\D/g, '');

        const verificationData = {
            account: {
                accountNumber,
                routingNumber
            },
            owner: hasAnyOwnerInput() ? {
                businessName,
                firstName,
                middleName,
                lastName,
                address: {
                    addressLine,
                    city,
                    state,
                    zipCode
                },
                einSSN: digitsOnly(einSSN),
                dateOfBirth,
                homePhone: digitsOnly(finalHomePhone),
                workPhone: digitsOnly(workPhone)
            } : null
        };

        setErrorMessage('');
        setIsSubmitting(true);
        
        const result = await submitVerification(verificationData);
        
        setIsSubmitting(false);
        setHasSubmitted(true);
        
        if (result.success) {
            setResponseData(result.data);
        } else {
            setErrorMessage(result.error || 'Failed to submit manual verification. Please try again.');
        }
    };

    return (
        <div className='Customer-Request-Confirmation-Backdrop'>
            <div className='Customer-Request-Confirmation Manual-Verification-Modal'>
                <div className='Customer-Request-Confirmation-Header'>
                    Manual Account Verification
                </div>

                <div className='Manual-Verification-Columns'>
                    {/* Account Verification Section */}
                    <div className='Customer-Request-Form-Section Manual-Verification-Section'>
                        <div className='Customer-Request-Section-Header'>
                            <h3>Account Verification</h3>
                        </div>
                        <div className='Customer-Request-Section-Content'>
                            <div className='Manual-Verification-Fields'>
                                <div className='Customer-Request-Record-Form-Under'>
                                    <div className='Customer-Request-Record-Form-Input-Title'>Account Number*:</div>
                                    <input
                                        value={accountNumber}
                                        onChange={e => setAccountNumber(e.target.value)}
                                        className='Customer-Request-Record-Form-Input'
                                        placeholder="Account Number*"
                                        required
                                    />
                                </div>
                                <div className='Customer-Request-Record-Form-Under'>
                                    <div className='Customer-Request-Record-Form-Input-Title'>Routing Number*:</div>
                                    <input
                                        value={routingNumber}
                                        onChange={e => setRoutingNumber(e.target.value)}
                                        className='Customer-Request-Record-Form-Input'
                                        placeholder="Routing Number*"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Owners Verification Section */}
                    <div className='Customer-Request-Form-Section Manual-Verification-Section'>
                        <div className='Customer-Request-Section-Header'>
                            <h3>Owners Verification</h3>
                            <div style={{fontSize: '11px', fontStyle: 'italic', marginTop: '3px', color: '#718096'}}>
                                Optional - If any field is filled, all * fields required
                            </div>
                        </div>
                        <div className='Customer-Request-Section-Content'>
                            <div className='Manual-Verification-Fields'>
                                <div className='Customer-Request-Record-Form-Under'>
                                    <div className='Customer-Request-Record-Form-Input-Title'>Business Name:</div>
                                    <input
                                        value={businessName}
                                        onChange={e => setBusinessName(e.target.value)}
                                        className='Customer-Request-Record-Form-Input'
                                        placeholder="Business Name"
                                    />
                                </div>
                                <div className='Customer-Request-Record-Form-Under'>
                                    <div className='Customer-Request-Record-Form-Input-Title'>First Name*:</div>
                                    <input
                                        value={firstName}
                                        onChange={e => setFirstName(e.target.value)}
                                        className='Customer-Request-Record-Form-Input'
                                        placeholder="First Name*"
                                    />
                                </div>
                                <div className='Customer-Request-Record-Form-Under'>
                                    <div className='Customer-Request-Record-Form-Input-Title'>Middle Name:</div>
                                    <input
                                        value={middleName}
                                        onChange={e => setMiddleName(e.target.value)}
                                        className='Customer-Request-Record-Form-Input'
                                        placeholder="Middle Name"
                                    />
                                </div>
                                <div className='Customer-Request-Record-Form-Under'>
                                    <div className='Customer-Request-Record-Form-Input-Title'>Last Name*:</div>
                                    <input
                                        value={lastName}
                                        onChange={e => setLastName(e.target.value)}
                                        className='Customer-Request-Record-Form-Input'
                                        placeholder="Last Name*"
                                    />
                                </div>
                                <div className='Customer-Request-Record-Form-Under'>
                                    <div className='Customer-Request-Record-Form-Input-Title'>Address Line*:</div>
                                    <input
                                        value={addressLine}
                                        onChange={e => setAddressLine(e.target.value)}
                                        className='Customer-Request-Record-Form-Input'
                                        placeholder="Address Line*"
                                    />
                                </div>
                                <div className='Manual-Verification-Row'>
                                    <div className='Customer-Request-Record-Form-Under' style={{flex: '2'}}>
                                        <div className='Customer-Request-Record-Form-Input-Title'>City*:</div>
                                        <input
                                            value={city}
                                            onChange={e => setCity(e.target.value)}
                                            className='Customer-Request-Record-Form-Input'
                                            placeholder="City*"
                                        />
                                    </div>
                                    <div className='Customer-Request-Record-Form-Under' style={{flex: '0.5'}}>
                                        <div className='Customer-Request-Record-Form-Input-Title'>State*:</div>
                                        <input
                                            value={state}
                                            onChange={e => setState(e.target.value)}
                                            className='Customer-Request-Record-Form-Input'
                                            placeholder="ST*"
                                            maxLength={2}
                                        />
                                    </div>
                                    <div className='Customer-Request-Record-Form-Under' style={{flex: '1'}}>
                                        <div className='Customer-Request-Record-Form-Input-Title'>Zip*:</div>
                                        <input
                                            value={zipCode}
                                            onChange={e => setZipCode(e.target.value)}
                                            className='Customer-Request-Record-Form-Input'
                                            placeholder="Zip*"
                                        />
                                    </div>
                                </div>
                                <div className='Customer-Request-Record-Form-Under'>
                                    <div className='Customer-Request-Record-Form-Input-Title'>EIN/SSN*:</div>
                                    <input
                                        value={einSSN}
                                        onChange={e => setEinSSN(formatEinSsn(e.target.value))}
                                        className='Customer-Request-Record-Form-Input'
                                        placeholder="XX-XXXXXXX"
                                    />
                                </div>
                                <div className='Customer-Request-Record-Form-Under'>
                                    <div className='Customer-Request-Record-Form-Input-Title'>Date of Birth:</div>
                                    <input
                                        type="date"
                                        value={dateOfBirth}
                                        onChange={e => setDateOfBirth(e.target.value)}
                                        className='Customer-Request-Record-Form-Input'
                                        placeholder="Date of Birth"
                                    />
                                </div>
                                <div className='Customer-Request-Record-Form-Under'>
                                    <div className='Customer-Request-Record-Form-Input-Title'>Work Phone:</div>
                                    <input
                                        value={workPhone}
                                        onChange={e => setWorkPhone(formatPhone(e.target.value))}
                                        className='Customer-Request-Record-Form-Input'
                                        placeholder="(XXX) XXX-XXXX"
                                    />
                                </div>
                                <div className='Customer-Request-Record-Form-Under'>
                                    <div className='Customer-Request-Record-Form-Input-Title'>Home Phone:</div>
                                    <input
                                        value={homePhone}
                                        onChange={e => setHomePhone(formatPhone(e.target.value))}
                                        className='Customer-Request-Record-Form-Input'
                                        placeholder="(XXX) XXX-XXXX"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {!isSubmitting && (
                    <div className='Customer-Request-Confirmation-Button-Group'>
                        <button 
                            onClick={handleSubmit} 
                            className='Customer-Request-Confirmation-Button Customer-Request-Confirm-Button'
                            disabled={!isValid()}
                        >
                            <FaCheck /> {hasSubmitted ? 'Resubmit Verification' : 'Submit Verification'}
                        </button>
                        <button 
                            onClick={closeModal} 
                            className='Customer-Request-Confirmation-Button Customer-Request-Deny-Button'
                        >
                            {responseData ? 'Close' : 'Cancel'}
                        </button>
                    </div>
                )}
                
                {isSubmitting && (
                    <div className='Manual-Verification-Loading'>
                        <RotatingLines
                            strokeColor="rgb(6, 89, 79)"
                            strokeWidth="5"
                            animationDuration="0.75"
                            width="60"
                            visible={true}
                        />
                        <div className='Manual-Verification-Loading-Text'>Submitting verification...</div>
                    </div>
                )}
                
                {errorMessage && (
                    <div className='Manual-Verification-Error'>
                        {errorMessage}
                    </div>
                )}
                
                {responseData && (
                    <div className='Manual-Verification-Response'>
                        <div className='Manual-Verification-Response-Header'>
                            Verification Response
                        </div>
                        <pre className='Manual-Verification-Response-Data'>
                            {JSON.stringify(responseData, null, 2)}
                        </pre>
                    </div>
                )}
            </div>
        </div>
    );
};

const VendorRequests = () => {
    const contextObject = useContext(Context);

    const [recordId, setRecordId] = useState();

    const [ orderBy, setOrderBy ] = useState('date');

    const [ sortDirection, setSortDirection ] = useState('ASC');
    const [ activeSort, setActiveSort ] = useState(true);

    const [ vendorList, setVendorList ] = useState([]);
    const [ vendorRecord, setVendorRecord ] = useState({});
    const [ searchInput, setSearchInput ] = useState('');
    const [ searchList, setSearchList] = useState([]);
    const [ headerFilters, setHeaderFilters ] = useState({
        requestType: '',
        businessName: '',
        location: '',
        date: '',
    });

    const [ approving, setApproving ] = useState(false);
    const [ approvalFinished, setApprovalFinished ] = useState(false);
    const [ showManualVerification, setShowManualVerification ] = useState(false);


    const approveVendorRecord = async (currency,require1099,type1099,foreignEntity,landedCost,isTaxAgency) => {
        try{
            setApprovalFinished(false);
            setApproving(true);
            const approvalObject = {
                vendorId: recordId,
                currency:currency,
                require1099:require1099,
                foreignEntity:foreignEntity,
                landedCost:landedCost,
                isTaxAgency:isTaxAgency,
                type1099:type1099,
            };
            const approval = await newVendorRequestService.approveRecord(contextObject.apiToken, approvalObject);
            console.log(approval.status)
            const boxFolderId = approval.data.box;
            const acumaticaId = approval.data.acumatica;
            if(approval.status > 199 && approval.status < 300){
                setApprovalFinished(true);
                window.open(`https://cornerstonedetentionproducts.app.box.com/folder/${boxFolderId}`)
                window.open(`https://cornerstoneinc.acumatica.com/Main?CompanyID=Pilot&ScreenId=AP303000&AcctCD=${acumaticaId}`)
            }
            else{
                console.log('APPROVAL FAILURE');
                alert('APPROVAL FAILURE');
            };
        }catch(error){
            alert('APPROVAL FAILED PLEASE CONTACT SYSTEM ADMINISTRATOR');
        };
    };

    const closeWindow = () => {
        setRecordId(null);
        setApproving(false);
        setApprovalFinished(false);
        refreshVendorList();
        setSearchInput('');
    };

    const openManualVerification = () => {
        setShowManualVerification(true);
    };

    const closeManualVerification = () => {
        setShowManualVerification(false);
    };

    const submitManualVerification = async (verificationData) => {
        try {
            // Transform the verification data into the required API format
            const payload = {
                verifyAccountOwners: [
                    {
                        id: 1,
                        accountNumber: verificationData.account.accountNumber,
                        routingNumber: verificationData.account.routingNumber,
                        profile: verificationData.owner ? {
                            firstName: verificationData.owner.firstName,
                            lastName: verificationData.owner.lastName,
                            ssnTIN: verificationData.owner.einSSN,
                            homePhoneNumber: verificationData.owner.homePhone || '',
                            workPhoneNumber: verificationData.owner.workPhone || '',
                            address: {
                                addressLine: verificationData.owner.address.addressLine,
                                city: verificationData.owner.address.city,
                                state: verificationData.owner.address.state,
                                zipCode: verificationData.owner.address.zipCode
                            }
                        } : null
                    }
                ]
            };

            const response = await newVendorRequestService.manualTruistVerify(contextObject.apiToken, payload);
            
            if (response.status === 200) {
                console.log('Verification response:', response.data);
                return { success: true, data: response.data };
            } else {
                return { success: false, error: 'Verification submitted but returned unexpected status.' };
            }
        } catch (error) {
            console.error('Manual verification failed:', error);
            const serverError = error.response?.data?.error;
            const serverDetails = error.response?.data?.details;

            let errorMsg = 'Failed to submit manual verification. Please try again.';

            if (serverError && serverDetails) {
                errorMsg = `${serverError}: ${serverDetails}`;
            } else if (serverDetails) {
                errorMsg = serverDetails;
            } else if (serverError) {
                errorMsg = serverError;
            } else if (error.response?.data?.message) {
                errorMsg = error.response.data.message;
            } else if (error.message) {
                errorMsg = error.message;
            }

            return { success: false, error: errorMsg };
        }
    };

    const rejectVendorRecord = ( rejectionText, closeRejection) => {
        const rejection = {
            vendorId:vendorRecord.id,
            text:rejectionText,
        };

        newVendorRequestService.submitRejectionRecord(contextObject.apiToken, rejection).then(res => {closeRejection(); refreshRecord()}).catch(err => {
            console.error('Rejection submission failed:', err);
        });
    };

    const markVendorInactive = () => {
        newVendorRequestService.inactivateRecord(contextObject.apiToken, recordId).then(res => {closeVendorRecord(); refreshVendorList()});
    };

    const markVendorActive = () => {
        newVendorRequestService.activateRecord(contextObject.apiToken, recordId).then(res => {closeVendorRecord(); refreshVendorList()});
    };

    const closeVendorRecord = () => {
        setRecordId(null);
    };

    const resetList = () => {
        setSearchInput('');
        setOrderBy('date');
        setActiveSort(true);
        setHeaderFilters({ requestType: '', businessName: '', location: '', date: '' });
        refreshVendorList();
        setSortDirection('ASC');
    };

    const selectSearchItem = (businessName) => {
        const filterObject = {
            searchInput:businessName,
        };
        newVendorRequestService.getVendorList(contextObject.apiToken, filterObject).then(res => setVendorList(res.data.vendorList));
    };

    const refreshSearchList = async () => {
        if(searchInput){
            const searchObject = {
                searchInput: searchInput,
            };
            newVendorRequestService.getSearchList(contextObject.apiToken, searchObject).then(res => setSearchList(res.data.searchList));
        }
    };

    useEffect(() => {
        refreshSearchList();
    },[searchInput]);

    useEffect(() => {
        console.log(vendorRecord);
    }, [vendorRecord]);

    const selectVendorRecord = (id) => {
        setRecordId(id);
        newVendorRequestService.getVendorRecord(contextObject.apiToken, id).then(res => setVendorRecord(res.data.vendorRecord));
    };

    const flipSortOrder = () => {
        if(sortDirection === 'ASC') setSortDirection('DESC');
        else setSortDirection('ASC');
    };

    const handleOrderClick = (newOrderBy) => {
        if(newOrderBy === orderBy) flipSortOrder();
        else setOrderBy(newOrderBy)
    };

    const toggleFlag = (id) => {
        newVendorRequestService.toggleVendorFlag(contextObject.apiToken, id).then(res => refreshVendorList());
    };

    const refreshVendorList = () => {
        const filterObject = {
            active: activeSort,
            sortDirection: sortDirection,
            orderBy:orderBy,
            searchInput:searchInput,
        };
        newVendorRequestService.getVendorList(contextObject.apiToken, filterObject).then(res => setVendorList(res.data.vendorList));
    };

    const refreshRecord = () => {
        if(recordId){
            newVendorRequestService.getVendorRecord(contextObject.apiToken, recordId).then(res => setVendorRecord(res.data.vendorRecord));
        }
    };

    useEffect(() => {
        refreshVendorList();
    },[sortDirection, orderBy, activeSort]);

    const vendorHeaderObject = {
        setSearchInput:setSearchInput,
        sortDirection:sortDirection,
        flipSortOrder:flipSortOrder,
        screenWidth:contextObject.screenWidth,
        handleOrderClick:handleOrderClick,
        orderBy: orderBy,
        searchList:searchList,
        selectSearchItem:selectSearchItem,
        resetList:resetList,
        activeSort:activeSort,
        setActiveSort:setActiveSort,
        headerFilters:headerFilters,
        setHeaderFilters:setHeaderFilters,
        openManualVerification:openManualVerification,
    };

    const vendorRequestObject = {
        vendorList:vendorList,
        selectVendorRecord:selectVendorRecord,
        toggleFlag:toggleFlag,
        screenWidth: contextObject.screenWidth,
        headerFilters:headerFilters,
    };

    const vendorRecordObject = {
        vendorRecord:vendorRecord,
        closeVendorRecord:closeVendorRecord,
        markVendorInactive:markVendorInactive,
        markVendorActive:markVendorActive,
        approveVendorRecord:approveVendorRecord,
        contextObject: contextObject,
        rejectVendorRecord:rejectVendorRecord,
        selectVendorRecord,
    };

    return(
        <div className='Vendor-Request-Window'>
            {   !recordId && !approving &&
            <>
                <VendorRequestHeader vendorHeaderObject={vendorHeaderObject}/>
                <VendorRequestDisplay vendorRequestObject={vendorRequestObject}/>      
            </>
            }
            {   recordId && !approving &&
                <VendorRecordWindow accessToken={contextObject.apiToken} vendorRecordObject={vendorRecordObject}/>
            }
            {   approving &&
                <ApprovalWindow approvalFinished={approvalFinished} closeWindow={closeWindow}/>
            }
            {   showManualVerification &&
                <ManualAccountVerificationModal 
                    closeModal={closeManualVerification} 
                    submitVerification={submitManualVerification}
                />
            }

        </div>
    )
};

export default VendorRequests;